import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { X, Languages } from "lucide-react";

// Prompt 3A-D: honest, non-noisy signal that a non-English page may still show
// some English while its translation is completed. One slim, dismissible bar.
export default function LangFallbackNotice() {
  const { lang, languages } = useLang();
  const native = (languages.find((l) => l.code === lang) || {}).native;
  const [hidden, setHidden] = useState(
    () => typeof sessionStorage !== "undefined" && sessionStorage.getItem(`dh_i18n_notice_${lang}`) === "1"
  );
  if (lang === "en" || hidden) return null;
  const dismiss = () => {
    try { sessionStorage.setItem(`dh_i18n_notice_${lang}`, "1"); } catch {}
    setHidden(true);
  };
  return (
    <div
      data-testid="lang-fallback-notice"
      className="flex items-center justify-center gap-2 bg-saffron/10 px-4 py-1.5 text-center text-xs text-ink-2"
    >
      <Languages className="h-3.5 w-3.5 shrink-0 text-saffron" />
      <span>
        Some text may still appear in English while the {native || lang} translation is being completed.
      </span>
      <button data-testid="lang-notice-dismiss" onClick={dismiss} className="ml-1 shrink-0 text-ink-3 hover:text-ink">
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
